import * as React from 'react';

var _path, _path2, _path3, _path4, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNftCollection = function SvgNftCollection(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_7609_450)",
        fillOpacity: 0.16,
        fillRule: "evenodd",
        d: "M20.802 46.539 5.263 37.976q-1.358-1.359-1.358-3.264t1.358-3.263L36.45 14.264C37.5 13.5 38.23 13 39.5 13c1.087 0 1.78.367 2.882.952q.277.147.594.312L74.16 31.449q1.359 1.358 1.359 3.263t-1.359 3.264l-12.539 6.91 15.539 8.563q1.359 1.358 1.359 3.263t-1.359 3.264L45.976 77.16c-.312.177-.581.34-.824.487-.905.549-1.438.872-2.44.872-1.188 0-1.214-.017-2.89-1.115l-.373-.244L8.263 59.976q-1.358-1.359-1.358-3.264t1.358-3.263z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_7609_450)",
        fillRule: "evenodd",
        d: "m72.292 42.158.42.584c.343.664.328 1.176.227 1.539a1.77 1.77 0 0 1-.524.843L41.989 62.083l-.03.017a35 35 0 0 1-1.61.908c-.287.15-.545.278-.745.364l-.115.048-.006-.003a5 5 0 0 1-.448-.217c-.351-.189-.723-.42-.953-.574a1 1 0 0 0-.086-.051c-4.666-2.5-11.813-6.349-18.094-9.772-6.314-3.442-11.67-6.41-12.82-7.177-.954-.636-1.263-1.356-1.31-1.936-.046-.56.145-1.053.382-1.348l.466-.416-1.686-1.31q-.096.06-.177.142c-.725.725-1.178 1.88-1.079 3.102.103 1.27.794 2.55 2.24 3.514 1.25.833 6.727 3.865 12.98 7.273a3070 3070 0 0 0 18.063 9.755c.27.18.677.432 1.08.648.21.113.438.226.654.314.177.072.485.186.805.186.222 0 .423-.06.53-.094.133-.043.273-.098.407-.156.27-.117.58-.271.888-.433.612-.32 1.272-.701 1.7-.958l30.486-16.992q.062-.035.119-.077c.497-.373 1.07-1.06 1.331-1.996.273-.976.181-2.147-.56-3.384a1.05 1.05 0 0 0-.32-.334z",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint2_linear_7609_450)",
        fillRule: "evenodd",
        d: "m72.287 52.546.425.58c.343.665.328 1.177.227 1.54a1.77 1.77 0 0 1-.524.843L41.989 72.467l-.03.017a35 35 0 0 1-1.61.908c-.287.151-.545.278-.745.365l-.115.047-.006-.002a5 5 0 0 1-.448-.217c-.351-.19-.723-.42-.953-.574a1 1 0 0 0-.086-.052c-4.666-2.5-11.813-6.348-18.094-9.771-6.314-3.443-11.67-6.41-12.82-7.177-.954-.636-1.263-1.356-1.31-1.936-.046-.56.145-1.053.382-1.349l.441-.434L4.935 51q-.097.06-.178.142c-.725.725-1.178 1.88-1.079 3.102.103 1.27.794 2.55 2.24 3.514 1.25.834 6.727 3.865 12.98 7.273a3069 3069 0 0 0 18.063 9.756c.27.179.677.431 1.08.647.21.114.438.227.654.314.177.072.485.186.805.186.222 0 .423-.06.53-.094.133-.042.273-.098.407-.156.27-.116.58-.27.888-.432.612-.321 1.272-.702 1.7-.958l30.486-16.992q.062-.035.119-.078c.497-.372 1.07-1.06 1.331-1.995.273-.977.181-2.148-.56-3.385a1.05 1.05 0 0 0-.32-.334z",
        clipRule: "evenodd"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint3_linear_7609_450)",
        d: "M36.449 55.161 5.264 37.976q-1.36-1.359-1.36-3.264t1.36-3.263l31.185-17.185C37.5 13.5 38.23 13 39.5 13s2 .5 3.476 1.264L74.16 31.449q1.359 1.358 1.359 3.263t-1.359 3.264L42.976 55.16C41.5 56 40.982 56.52 39.712 56.52S38 56 36.45 55.16M6.533 34.712q0 .273.09.68.09.409.454.77L21 44l21.142-11.717-2.43 21.609q.273 0 .68-.09.409-.091.77-.454l31.186-17.185q.635-.635.635-1.45 0-.817-.635-1.451l-15.593-8.593-14.613 7.614z"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_7609_450",
        x1: 4.684,
        x2: 77.481,
        y1: 45.76,
        y2: 45.76,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_7609_450",
        x1: 4.411,
        x2: 74.107,
        y1: 53.083,
        y2: 53.083,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_7609_450",
        x1: 4.411,
        x2: 74.107,
        y1: 63.467,
        y2: 63.467,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint3_linear_7609_450",
        x1: 21.25,
        x2: 58.044,
        y1: 16.25,
        y2: 53.043,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgNftCollection as ReactComponent };
//# sourceMappingURL=NFTCollection.svg.es.js.map
